import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide"
import "@splidejs/react-splide/css"
import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import Image from "components/elements/image"
import PropTypes from "prop-types"
import React from "react"

import "./carousel.scss"

const Carousel = ({ callsToAction, slides }) => {
  return (
    <div className="section-split-image-carousel-v2--carousel">
      <Splide
        aria-label="Split Image Carousel"
        hasTrack={false}
        options={{
          type: "fade",
          arrows: slides?.length > 1,
          drag: true,
          autoplay: true,
          pauseOnHover: true,
          interval: 4000,
          rewind: true,
          gap: "16px",
          pagination: false,
          perMove: 1,
          perPage: 1,
          speed: 300,
          easing: "ease-in-out",
          arrowPath: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18"><path stroke="#f9f8f2" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.463" d="M8.799 3.667 13.932 8.8m0 0L8.8 13.933M13.932 8.8H3.665"/></svg>`,
        }}
      >
        <SplideTrack>
          {slides?.length > 0 &&
            slides.map(slide => (
              <SplideSlide key={slide.id}>
                <div className="section-split-image-carousel-v2--slide-content">
                  {slide?.image && (
                    <div className="section-split-image-carousel-v2--image-container">
                      <Image
                        alt={slide.title}
                        className="section-split-image-carousel-v2--carousel-image"
                        image={slide.image.fluid}
                        title={slide.title}
                      />
                    </div>
                  )}
                  {slide?.heading ||
                    (slide.subHeading && (
                      <div className="section-split-image-carousel-v2--slide-details">
                        <h3 className="section-split-image-carousel-v2--slide-heading">
                          {slide.heading}
                        </h3>
                        <p className="section-split-image-carousel-v2--slide-subHeading">
                          {slide.subHeading}
                        </p>
                      </div>
                    ))}
                </div>
              </SplideSlide>
            ))}
        </SplideTrack>
        {slides?.length > 1 && (
          <div className="splide__arrows">
            test
            <button
              aria-label="Previous"
              className="splide__arrow splide__arrow--prev"
            >
              <svg
                fill="none"
                height="18"
                viewBox="0 0 18 18"
                width="18"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.801 13.933 3.668 8.8m0 0 5.133-5.133M3.668 8.8h10.267"
                  stroke="#f9f8f2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.463"
                />
              </svg>
            </button>
            <button
              aria-label="Next"
              className="splide__arrow splide__arrow--next"
            >
              <svg
                fill="none"
                height="18"
                viewBox="0 0 18 18"
                width="18"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.799 3.667 13.932 8.8m0 0L8.8 13.933M13.932 8.8H3.665"
                  stroke="#f9f8f2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.463"
                />
              </svg>
            </button>
          </div>
        )}
      </Splide>

      <div className="section-split-image-carousel-v2--cta-buttons under-image-button">
        {callsToAction?.length > 0 &&
          callsToAction?.map(ctaButton => (
            <p
              className="section-split-image-carousel-v2--cta-button"
              key={ctaButton.id}
            >
              <ButtonV2
                accessibilityLabel={ctaButton.accessibilityLabel}
                className={getButtonClasses(
                  ctaButton.buttonStyle,
                  ctaButton.buttonSize
                )}
                href={ctaButton.path}
                key={ctaButton.id}
                showArrow={ctaButton.showArrow === "Yes" ? true : false}
                text={ctaButton.text}
              />
            </p>
          ))}
      </div>
    </div>
  )
}

Carousel.propTypes = {
  callsToAction: PropTypes.arrayOf(
    PropTypes.shape({
      accessibilityLabel: PropTypes.string.isRequired,
      buttonStyle: PropTypes.string.isRequired,
      buttonSize: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      showArrow: PropTypes.bool.isRequired,
      id: PropTypes.string.isRequired,
    })
  ),
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.shape({
        fluid: PropTypes.shape({
          src: PropTypes.string.isRequired,
          width: PropTypes.number.isRequired,
          height: PropTypes.number.isRequired,
        }).isRequired,
      }).isRequired,
      heading: PropTypes.string,
      subHeading: PropTypes.string,
    })
  ),
}

export default Carousel
